import { CumulativeInvoice } from "@oldDashboard/legacyModels/cumulativeInvoice";
import { CumulativeInvoiceSerializer } from "@oldDashboard/legacyModels/serializers/cumulativeInvoiceSerializer";
import { legacyReportingGet } from "@oldDashboard/legacyUtils";

export class CommandCumulativeInvoice {

    async run(launchSelected: String, timePeriodSelected: String) {
        const path = `get-chart-data/client:invoice-cap-summary/?launch_id=${launchSelected}&time_period=${timePeriodSelected}`
        try {
            const response = await legacyReportingGet(path);
            if (response.success) {
                return this.deserialize(response);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }

    }

    deserialize(data: any) : CumulativeInvoice {
        const serializer = new CumulativeInvoiceSerializer();
        const obj = {
                ...data.chart_data.data_points[0],
                visible: data.chart_data.show_revenue_tile,
                billingType: data.chart_data.census_type
            }
        return serializer.deserialize(obj);
    }
}

